import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=170a1cb8"
import script from "./forgot-password.vue?vue&type=script&lang=ts"
export * from "./forgot-password.vue?vue&type=script&lang=ts"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=170a1cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports